export const INTRO_VIDEO_EXPERIMENT_LPS = [2 /* en/es */, 10 /* en-us/es */];
export const CONNECT_PROMO_DISMISSED_LPS_STORAGE_KEY = 'connect_promo_dismissed_lps';
